import { Chip, TableCell, TableRow, TextField, IconButton, Tooltip, Badge } from "@mui/material";
import { Stack } from "@mui/system";
import { useForm } from "react-hook-form";
import MultiSelectMenu from "./customize/multi-select-menu";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import toast from "react-hot-toast";
import DoneIcon from '@mui/icons-material/Done';
import { useEffect, useState } from 'react'
import { customersApi } from "../api/customers";
import { DeleteModal } from "./customize/delete-modal";


export const LabelItem = (props) => {
  const { label, teams, deleteLabels, updateLabels } = props;

  const { register, control, setValue, watch } = useForm();

  const [isPending, setIsPending] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);

  const onSubmit = async (isDefault) => {
    const data = watch();
    if (isDefault) {
      delete data?.name;
      delete data?.team_client_label_ids;
    }
    setIsPending(true);
    try {
      const res = await customersApi.updateCustomerLabel({ ...data, id: label?.id });
      updateLabels(res?.label);
      toast('Label successfully updated!')
    } catch (error) {
      console.error('error: ', error);
    }
    setIsPending(false);
  };

  const deleteLabel = async () => {
    setIsPending(true);
    try {
      await customersApi.deleteCustomerLabel(label?.id);
      deleteLabels(label?.id);
      toast('Label successfully deleted!')
    } catch (error) {
      console.error('error: ', error);
    }
    setIsPending(false);
    setModalOpen(false);
  };

  useEffect(() => {
    setValue('team_client_label_ids', label?.team_client_label_ids);
    setValue('name', label?.name);
    setValue('color', label?.color);
  }, []);

  const chipColor = watch('color')
  return (
    <>
      <TableRow key={label.id}>
        <TableCell>
          {label?.default ?
            <Badge
              variant="dot"
              color="success">
              <Tooltip
                placement="top"
                title="Default Label">
                <TextField
                  disabled={label?.default}
                  size="small"
                  hiddenLabel
                  {...register('name')}
                  sx={{ width: 120 }}
                />
              </Tooltip>
            </Badge>
            :
            <TextField
              disabled={label?.default}
              size="small"
              hiddenLabel
              {...register('name')}
              sx={{ width: 120 }}
            />
          }
        </TableCell>
        <TableCell sx={{ minWidth: 100, pr: 0 }}>
          <Stack
            direction="row"
            alignItems="center"
            gap={1}>
            <label
              htmlFor={label.id}>
              <Chip
                label={chipColor ?? 'Default'}
                color='primary'
                sx={{ backgroundColor: chipColor ?? "" }} />
            </label>
            <input
              style={{ visibility: 'hidden', width: '0px', height: '0px' }}
              id={label.id}
              type="color"
              {...register('color')}
            />
          </Stack>
        </TableCell>
        <TableCell>
          <MultiSelectMenu
            disabled={label?.default}
            isSmall
            control={control}
            name="team_client_label_ids"
            list={teams}
          />
        </TableCell>
        <TableCell>
          <Stack direction='row'>
            <Tooltip
              placement="top"
              title="Update">
              <IconButton
                disabled={isPending}
                sx={{ p: 0, pr: 1 }}
                onClick={() =>
                  onSubmit(label?.default)
                }>
                <DoneIcon
                  color="success"
                />
              </IconButton>
            </Tooltip>
            <Tooltip
              placement="top"
              title="Delete">
              <IconButton
                disabled={isPending || label?.default}
                onClick={() => setModalOpen(true)}>
                <DeleteOutlineIcon
                  fontSize="medium"
                  color="error"
                  sx={(theme) => ({
                    color: label?.default ? 'gray' : theme.palette.error.main
                  })}
                />
              </IconButton>
            </Tooltip>
          </Stack>
        </TableCell>
      </TableRow>
      <DeleteModal
        isOpen={modalOpen}
        setIsOpen={() => setModalOpen(false)}
        onDelete={() => deleteLabel()}
        title={'Delete Label'}
        description={'Are you sure you want to delete this Label?'}
      />
    </>
  );
};
